import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CrmArticlesPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/articles/$articleId')({
  params: z.object({ articleId: z.uuid() }),
  component: ArticleRoute,
});
function ArticleRoute() {
  const { locale, articleId } = Route.useParams();
  return (
    <CrmArticlesPage
      locale={locale}
      articleId={articleId}
      search={Route.useSearch()}
      mode="detail"
    />
  );
}
